import api from '@/apis'

export default {
  state: {
    visibility: false,
    is_submit_btn_disable: false
  },
  mutations: {
    INIT_ADD_USER_DIALOG(state) {
      state.visibility = true
    },
    RESET_ADD_USER_DIALOG(state) {
      state.visibility = false
    },
    SET_ADD_USER_DIALOG_VISIBILITY(state, payload) {
      state.visibility = payload
    },
    SET_ADD_USER_DIALOG_IS_SUBMIT_BTN_DISABLE(state, payload) {
      state.is_submit_btn_disable = payload
    }
  },
  actions: {
    async createUser({ commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Adding User', loading: true })

        commit('SET_ADD_USER_DIALOG_IS_SUBMIT_BTN_DISABLE', true)

        const response = await api.addUser({ params: payload })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
          commit('RESET_ADD_USER_DIALOG')
          dispatch('fetchUserManagementList')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_ADD_USER_DIALOG_IS_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
